import { connect } from 'react-redux';
import ArcadeWrapper from './Wrapper';
import { clearArcade } from './actions';
import { hasArcadeCabinets } from './sections/cabinets/selectors';

const mapStateToProps = state => ({
    hasArcadeCabinets: hasArcadeCabinets(state)
});

export default connect(mapStateToProps, { clearArcade })(ArcadeWrapper);
